<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-tap`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M33 7a1 1 0 00-1-1H16a1 1 0 00-1 1v2a1 1 0 001 1h6v4.153A13.005 13.005 0 0013.043 20H6v-1a1 1 0 00-1-1H3a1 1 0 00-1 1v16a1 1 0 001 1h2a1 1 0 001-1v-1h7.044A12.99 12.99 0 0024 40a12.99 12.99 0 0010.956-6H42v1a1 1 0 001 1h2a1 1 0 001-1V19a1 1 0 00-1-1h-2a1 1 0 00-1 1v1h-7.043A13.005 13.005 0 0026 14.154V10h6a1 1 0 001-1V7zm-9 10.892l-1.39.214a9.004 9.004 0 00-6.198 4.051l-1.18 1.844L6 24v6h9.232l1.18 1.843A8.989 8.989 0 0024 36a8.989 8.989 0 007.587-4.157L32.767 30H42v-6h-9.232l-1.18-1.843a9.004 9.004 0 00-6.198-4.05L24 17.891z"/></svg>
</template>
<script>

export default {
  name: 'IconTap',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
